import { render } from "./AboutView.vue?vue&type=template&id=47785fa8&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=47785fa8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47785fa8"

export default script